<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>工资预支使用说明:<br>
					<span>1、单号构成规则:201201+GRGZ+4位顺序号。系统生成,添加无效</span><br>
					<span class="red">2、预支情景约定金额等于0时,预支时间范围最多超过当前日期一个月。</span><br>
					<span class="red">3、预支情景约定金额大于0时,每月从工资中扣除约定金额,注意约定金额应小于每月应发工资。</span><br>
					<span>4、如果在汇总约定金额大于0的时，计算出的工资结果是负数,则不汇总该单据!</span><br>
					<span>5、查询关键字:单号、申请人、状态。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "advance",
					"title": "工资预支申请",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_kq_advance_m',
					"upd_action": 'exp15_kq_advance_m',
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": 'advance_m',
					"p1": 'bdwl',
					"p2": 'advance',
					"p3": '',
					"parm_sel": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "预支月份",
							"val": "",
							"key": "gz_date",
							"type": "month",
							"class": "long1",
							"sel": "2",
						},
						{
							"name": "预支人",
							"val": "",
							"key": "u_name2",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel_val": {},
							"sel": "4"
						},
						{
							"name": "生成主单号",
							"val": "",
							"key": "from_no",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
					],
					"parm": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "预支月份",
							"val": "",
							"key": "gz_month",
							"type": "month",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "1"
						},
						{
							"name": "预支人",
							"val": "",
							"key": "u_name2",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "预支金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "1"
						},
						{
							"name": "财务确认",
							"val": "",
							"key": "amount_ok",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "相应月工资单号",
							"val": "",
							"key": "sheet_gz",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "相应月工资审核",
							"val": "",
							"key": "amount_gz",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "实际预支",
							"val": "",
							"key": "amount_end",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "约定金额",
							"val": "",
							"key": "agree_pay",
							"type": "number",
							"class": "black",
							"note":"每月扣除",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						}, 
						{
							"name": "业务单号"
						}, 
						{
							"name": "预支月"
						},
						{
							"name": "部门"
						},
						{
							"name": "预支人"
						},
						{
							"name": "预支金额"
						},
						{
							"name": "财务确认"
						},
						{
							"name": "相应月工资单号"
						},

						{
							"name": "相应月工资审核"
						},
						{
							"name": "实际预支"
						},
						{
							"name": "工资冲账"
						},
						{
							"name": "工资挂帐"
						},
						{
							"name": "打款凭证"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "约定金额"
						},
						{
							"name": "生成主单"
						},
						{
							"name": "是否使用"
						},
						{
							"name": "使用工单"
						},
						{
							"name": "附件"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "浏览地址"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [
					],
					"d_name": [
					]

				});



				// console.log(this.$refs);
				// this.$refs.mybase.load_data();
				// 解决偶尔第一次没有加载完成时再次 调用一下
				// var that = this;
				// this.$nextTick(function() {
				// 	that.$refs.mybase.load_data();
				// });

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>
